import { Engine } from 'engine/Engine';
import { Facet } from 'engine/facets/Facet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { HealthBarProps } from './HealthBarProps';
import { HealthBarSprite } from './HealthBarSprite';

export class HealthBarBehavior extends Facet<HealthBarProps> {

  sprite = create(StaticSpriteFacet, { frame: null });

  start(engine: Engine) {
    this.entity.addFacet(this.sprite, engine);
  }

  update() {
    this.sprite.props.offset = this.props.offset;
    this.sprite.props.frame = HealthBarSprite(this.props);
  }
}
